import {
  Card,
  Radio,
  Input,
  Checkbox,
  Button,
  Alert,
  Tag,
  Flex,
  Typography,
  Divider,
  Space,
  Row,
  Col,
  Spin,
  Modal,
} from "antd"
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  ExclamationCircleOutlined,
  UserOutlined,
  SaveOutlined,
  FileTextOutlined,
  WarningOutlined,
  DisconnectOutlined,
  TeamOutlined,
  QuestionCircleOutlined,
  FormOutlined,
} from "@ant-design/icons"
import {
  enumToArray,
  getInspectionStatusEnum,
  serializeQuery,
} from "helpers/service_helper"
import { InspectionParameterType } from "models/types/inspection_parameter_type"
import React, { useState, useReducer, useEffect } from "react"
import DesignFormReport from "./DesignFormReport"

const { TextArea } = Input
const { Title, Text } = Typography

export const SubmitDesign = ({ rowData, mainProps }) => {
  const { onGetProjectFiles, lstGasProjectFiles } = mainProps
  const { t } = mainProps
  const [isErrorValid, setIsErrorValid] = useState(false)
  const [noCooperation, setNoCooperation] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      inspectionStatus: 0,
      description: "",
      defect: false,
      inspectionParameterType: getInspectionStatusEnum(
        rowData.gasProjectDetail.totalUsage
      ),
      isWorkDone: "false",
      isPresentExe: "true",
      totalGasUse: rowData.gasProjectDetail.totalUsage,
      totalPipeUse: rowData.totalPipeUse ? rowData.totalPipeUse : 1,
      disapprovalTypeEnum: 1,
      checkedApproved: +rowData.inspectionStatus === 1 ? true : false,
    }
  )

  const resetForm = async () => {
    await onGetProjectFiles(rowData.gasProject.id)
    setFormInput({ description: "" })
    setFormInput({ inspectionStatus: 0 })
    setFormInput({ isWorkDone: "false" })
    setFormInput({ isPresentExe: "true" })
    setFormInput({ defect: false })
    setFormInput({ inspectionParameterType: 0 })
    setFormInput({ checkedApproved: false })
  }

  const [open, setOpen] = useState(false)
  const [inspectionParameterType, setInspectionParameterType] = useState([])

  const handleInput = evt => {
    setHasError(false)
    const name = evt.target.name
    const newValue = evt.target.value
    if (name === "checkedApproved") {
      setFormInput({ ["checkedApproved"]: evt.target.checked ?? false })
      return
    }
    setFormInput({ [name]: newValue })
  }

  const handleRadioChange = (name, value) => {
    setHasError(false)
    setFormInput({ [name]: value })
  }

  const date1 = new Date(rowData.julianRegisterDate)
  const date2 = new Date("2024-08-24")

  useEffect(() => {
    setInspectionParameterType(enumToArray(InspectionParameterType))
    resetForm()
  }, [])

  const handleSubmitForm = async (event) => {
    const { onSubmitDesignStage } = mainProps
    event.preventDefault()

    let mapToSave = {
      inspectionStatus: +formInput.inspectionStatus,
      idGasProjectProcess: rowData.id,
      description: noCooperation
        ? "-عدم همکاری/حضور-" + formInput.description
        : formInput.description,
      disapprovalTypeEnum: +formInput.disapprovalTypeEnum,
    }

    if (
      mapToSave.inspectionStatus === 1 &&
      mapToSave.inspectionParameterType <= 0
    ) {
      Modal.warning({
        title: "توجه",
        content: "جهت مشخص کردن پارامتر بازرسی جمع مصرف در بخش الزامات باید وارد شود",
      })
      return
    }

    const confirmMessages = {
      1: "آیا مطمئن هستید که طراحی را تایید میکنید؟",
      2: "آیا مطمئن هستید که این پرونده را تایید نمیکنید",
      3: "آیا مطمئن هستید که طراحی را کنسل میکنید؟",
    }

    if (confirmMessages[mapToSave.inspectionStatus]) {
      Modal.confirm({
        title: "تایید عملیات",
        icon: <ExclamationCircleOutlined />,
        content: confirmMessages[mapToSave.inspectionStatus],
        okText: "بله",
        cancelText: "خیر",
        onOk: async () => {
          await onSubmitDesignStage({
            process: mapToSave,
            queryString: serializeQuery({ idFile: rowData.idFile }),
          })
          setOpen(false)
        },
      })
    }
  }

  // Status options configuration
  const statusOptions = [
    {
      value: 1,
      label: "پیش نمایش و تایید",
      icon: <CheckCircleOutlined />,
      color: "#52c41a",
      bgColor: "#f6ffed",
      borderColor: "#b7eb8f",
      disabled: false,
    },
    {
      value: 2,
      label: "عدم تایید",
      icon: <CloseCircleOutlined />,
      color: "#ff4d4f",
      bgColor: "#fff2f0",
      borderColor: "#ffccc7",
      disabled: false,
    },
    {
      value: 3,
      label: "عدم قبول این پرونده (کنسل)",
      icon: <StopOutlined />,
      color: "#faad14",
      bgColor: "#fffbe6",
      borderColor: "#ffe58f",
      disabled: date1 < date2,
    },
  ]

  // Disapproval reasons configuration
  const disapprovalReasons = [
    {
      value: 1,
      label: "انشعاب تعلق نمیگیرد",
      icon: <DisconnectOutlined />,
      color: "#722ed1",
    },
    {
      value: 2,
      label: "عدم همکاری مجری",
      icon: <TeamOutlined />,
      color: "#eb2f96",
    },
    {
      value: 3,
      label: "عدم وجود علمک",
      icon: <WarningOutlined />,
      color: "#fa8c16",
    },
    {
      value: 5,
      label: "سایر",
      icon: <QuestionCircleOutlined />,
      color: "#1890ff",
    },
  ]

  return (
    <div>
      <form onSubmit={handleSubmitForm}>
        {/* Status Selection Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <FormOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              انتخاب وضعیت طراحی
            </Title>
          </Flex>

          <Radio.Group
            value={+formInput.inspectionStatus}
            onChange={(e) => handleRadioChange("inspectionStatus", e.target.value)}
            style={{ width: "100%" }}
          >
            <Row gutter={[12, 12]}>
              {statusOptions.map((option) => (
                <Col xs={24} sm={12} md={8} key={option.value}>
                  <Radio.Button
                    value={option.value}
                    disabled={option.disabled}
                    style={{
                      width: "100%",
                      height: "auto",
                      padding: "16px",
                      borderRadius: 10,
                      border:
                        +formInput.inspectionStatus === option.value
                          ? `2px solid ${option.color}`
                          : `1px solid ${option.borderColor}`,
                      background:
                        +formInput.inspectionStatus === option.value
                          ? option.bgColor
                          : "#fff",
                      opacity: option.disabled ? 0.5 : 1,
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Flex vertical align="center" gap={8}>
                      <span style={{ fontSize: 24, color: option.color }}>
                        {option.icon}
                      </span>
                      <Text
                        strong
                        style={{
                          color:
                            +formInput.inspectionStatus === option.value
                              ? option.color
                              : "#595959",
                        }}
                      >
                        {option.label}
                      </Text>
                    </Flex>
                  </Radio.Button>
                </Col>
              ))}
            </Row>
          </Radio.Group>
        </Card>

        {/* Disapproval Reasons Card */}
        {+formInput.inspectionStatus === 2 && (
          <Card
            style={{
              borderRadius: 12,
              marginBottom: 16,
              border: "1px solid #ffccc7",
              background: "#fff2f0",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            <Flex align="center" gap={8} style={{ marginBottom: 12 }}>
              <CloseCircleOutlined style={{ fontSize: 18, color: "#ff4d4f" }} />
              <Title level={5} style={{ margin: 0, color: "#cf1322" }}>
                دلیل عدم تایید
              </Title>
            </Flex>

            <Alert
              message="با انتخاب این گزینه به میزان 50 درصد تعرفه کسر میگردد"
              type="warning"
              showIcon
              icon={<WarningOutlined />}
              style={{ marginBottom: 16, borderRadius: 8 }}
            />

            <Radio.Group
              value={+formInput.disapprovalTypeEnum}
              onChange={(e) => handleRadioChange("disapprovalTypeEnum", e.target.value)}
              style={{ width: "100%" }}
            >
              <Row gutter={[12, 12]}>
                {disapprovalReasons.map((reason) => (
                  <Col xs={24} sm={12} md={6} key={reason.value}>
                    <Radio.Button
                      value={reason.value}
                      style={{
                        width: "100%",
                        height: "auto",
                        padding: "12px",
                        borderRadius: 8,
                        border:
                          +formInput.disapprovalTypeEnum === reason.value
                            ? `2px solid ${reason.color}`
                            : "1px solid #d9d9d9",
                        background:
                          +formInput.disapprovalTypeEnum === reason.value
                            ? "#fafafa"
                            : "#fff",
                        textAlign: "center",
                      }}
                    >
                      <Flex vertical align="center" gap={6}>
                        <span style={{ fontSize: 20, color: reason.color }}>
                          {reason.icon}
                        </span>
                        <Text
                          style={{
                            fontSize: 12,
                            color:
                              +formInput.disapprovalTypeEnum === reason.value
                                ? reason.color
                                : "#595959",
                          }}
                        >
                          {reason.label}
                        </Text>
                      </Flex>
                    </Radio.Button>
                  </Col>
                ))}
              </Row>
            </Radio.Group>
          </Card>
        )}

        {/* Description Card */}
        {+formInput.inspectionStatus !== 1 && +formInput.inspectionStatus !== 0 && (
          <Card
            style={{
              borderRadius: 12,
              marginBottom: 16,
              border: "none",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            <Flex align="center" gap={8} style={{ marginBottom: 12 }}>
              <FileTextOutlined style={{ fontSize: 18, color: "#667eea" }} />
              <Title level={5} style={{ margin: 0 }}>
                توضیحات
              </Title>
              <Tag color="red">الزامی</Tag>
            </Flex>

            <TextArea
              rows={4}
              placeholder="توضیحات خود را وارد کنید..."
              value={formInput.description || ""}
              name="description"
              onChange={handleInput}
              style={{
                borderRadius: 8,
                resize: "none",
              }}
            />
          </Card>
        )}

        {/* Design Form Report & Confirmation Card */}
        {+formInput.inspectionStatus === 1 && (
          <Card
            style={{
              borderRadius: 12,
              marginBottom: 16,
              border: "1px solid #b7eb8f",
              background: "#f6ffed",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
              <CheckCircleOutlined style={{ fontSize: 18, color: "#52c41a" }} />
              <Title level={5} style={{ margin: 0, color: "#389e0d" }}>
                پیش نمایش و تایید طراحی
              </Title>
            </Flex>

            {/* Design Form Report */}
            <div style={{ marginBottom: 16 }}>
              <DesignFormReport
                lstGasProjectFiles={lstGasProjectFiles}
                model={rowData}
              />
            </div>

            <Divider style={{ margin: "16px 0" }} />

            {/* Confirmation Section */}
            <Card
              size="small"
              style={{
                borderRadius: 8,
                background: "#fff",
                border: "1px solid #d9f7be",
              }}
            >
              <Text style={{ lineHeight: 2, fontSize: 14 }}>
                {date1 > date2 ? (
                  <>
                    اینجانب مهندس{" "}
                    <Tag color="blue" style={{ margin: "0 4px" }}>
                      <UserOutlined style={{ marginLeft: 4 }} />
                      {rowData.enName}
                    </Tag>{" "}
                    نقشه با مشخصات فوق را مطابق مبحث 17 طراحی و تمام مسئولیت های آن را
                    به عهده می گیرم.
                  </>
                ) : (
                  <>
                    <Alert
                      message="تازمان استقرار کامل سامانه طراحی گاز، این برگه کارشناسی از نظر واحد نظارت گازرسانی قابل قبول می باشد"
                      type="info"
                      showIcon
                      style={{ marginBottom: 12, borderRadius: 8 }}
                    />
                    اینجانب مهندس{" "}
                    <Tag color="blue" style={{ margin: "0 4px" }}>
                      <UserOutlined style={{ marginLeft: 4 }} />
                      {rowData.enName}
                    </Tag>{" "}
                    کارشناسی با مشخصات فوق را تایید می نمایم.
                  </>
                )}
              </Text>

              <div style={{ marginTop: 16 }}>
                <Checkbox
                  checked={formInput.checkedApproved ?? false}
                  onChange={(e) =>
                    setFormInput({ checkedApproved: e.target.checked })
                  }
                  name="checkedApproved"
                >
                  <Text strong style={{ color: "#389e0d" }}>
                    تایید و پذیرش مسئولیت
                  </Text>
                   <Text strong style={{ color: "#ff4000", fontSize: 18 }}>
                    لطفا دقت فرمایید شما در حال تایید کردن این پرونده با تعداد واحد: 
                     {rowData?.gasProject?.unitNumber}
                     می باشید و قابل تغییر نمی باشد آیا مطمن هستید؟؟؟
                  </Text>
                </Checkbox>
              </div>
            </Card>
          </Card>
        )}

        {/* Action Card */}
        <Card
          style={{
            borderRadius: 12,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {mainProps.success && (
              <Alert
                message="اطلاعات با موفقیت ذخیره شد"
                type="success"
                showIcon
                style={{ borderRadius: 8 }}
              />
            )}

            {mainProps.error && (
              <Alert
                message={mainProps.error}
                type="error"
                showIcon
                style={{ borderRadius: 8 }}
              />
            )}

            <Flex justify="flex-start" align="center" gap={12}>
              {mainProps.loading ? (
                <Button
                  type="primary"
                  loading
                  style={{
                    borderRadius: 8,
                    height: 44,
                    paddingInline: 32,
                  }}
                >
                  در حال ذخیره...
                </Button>
              ) : rowData.projectLevel === 4 && +formInput.inspectionStatus !== 0 ? (
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={
                    !formInput.checkedApproved && +formInput.inspectionStatus === 1
                  }
                  icon={<SaveOutlined />}
                  style={{
                    borderRadius: 8,
                    height: 44,
                    paddingInline: 32,
                    background:
                      !formInput.checkedApproved && +formInput.inspectionStatus === 1
                        ? undefined
                        : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    border: "none",
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                  }}
                >
                  ذخیره اعلام نظر
                </Button>
              ) : (
                <Tag
                  color="default"
                  style={{
                    padding: "8px 16px",
                    borderRadius: 8,
                    fontSize: 14,
                  }}
                >
                  <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                  لطفاً یک وضعیت را انتخاب کنید
                </Tag>
              )}
            </Flex>
          </Space>
        </Card>
      </form>
    </div>
  )
}
